import { render, staticRenderFns } from "./UserArticleListUserInfo.vue?vue&type=template&id=ddbdb60c&scoped=true&"
import script from "./UserArticleListUserInfo.vue?vue&type=script&lang=js&"
export * from "./UserArticleListUserInfo.vue?vue&type=script&lang=js&"
import style0 from "./UserArticleListUserInfo.vue?vue&type=style&index=0&id=ddbdb60c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddbdb60c",
  null
  
)

export default component.exports